import { render } from "./BaseTags.vue?vue&type=template&id=62e1ba80&ts=true"
import script from "./BaseTags.vue?vue&type=script&lang=ts"
export * from "./BaseTags.vue?vue&type=script&lang=ts"

import "./BaseTags.vue?vue&type=style&index=0&id=62e1ba80&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__